import axios from '@/config/httpConfig'
// 搜索用户组
export function queryPopupType(data) {
    return axios.post('/sse/setup/queryPopupType', data)
}
